import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/**
 * Rôle dans une société (enum App\Entity\CompanyRole de l'API, GET /company_roles) : id, reference (clé utilisée par le
 * front), label, position (ordre d'affichage : Dirigeant, Assistant, Employé)
 */
export default class CompanyRoleModel extends AbstractApiModel {
  protected _path = '/company_roles/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** Ordre d'affichage ; undefined si l'API ne le donne pas (@doc.number renverrait 0) */
  get position(): number | undefined {
    return this.get<number | undefined, undefined>('position', undefined);
  }

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:company_role:${this.id}`);
  }
}
